/* projects/speaker-platform/src/app/organisms/text-focus/text-focus.component.scss */
.infoText {
  padding: 10px;
  border-radius: 13px;
  background-color: #f7F7F7;
  border-right: 2px solid #fced01;
  border-bottom: 2px solid #fced01;
  display: flex;
  flex-direction: column;
}
.infoText .subtitle {
  font-size: 15px;
  padding-bottom: 6px;
}
.infoText .content-main {
  align-content: center;
  font-size: 18px;
  font-weight: 500;
}
.infoText .content-text {
  font-size: 18px;
}
/*# sourceMappingURL=text-focus.component-B6MGVIZC.css.map */
